import {useState, useEffect, useRef} from 'react';
import './ReviewPage.css';

export const useUIState = (isCreate) => {
    // Breakpoint: en dessous de cette taille, la sidebar critères est cachée par défaut.
    // 1400px = laisse la place aux 3 colonnes même sur un laptop 14" (1366–1536px CSS).
    const BREAKPOINT = 1400;

    const [isCriteriaDrawerOpen, setIsCriteriaDrawerOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < BREAKPOINT);
    const [isCriteriaSidebarOpen, setIsCriteriaSidebarOpen] = useState(window.innerWidth >= BREAKPOINT);
    const [isCommentsSidebarOpen, setIsCommentsSidebarOpen] = useState(true);
    const [rightPanelMode, setRightPanelMode] = useState("comments");
    const [showAllComments, setShowAllComments] = useState(true);
    const [hoveredRef, setHoveredRef] = useState(null);
    const [selectedRef, setSelectedRef] = useState(null);

    const prevIsSmallRef = useRef(window.innerWidth < BREAKPOINT);

    useEffect(() => {
        let resizeTimer;

        const handleResize = () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                const isSmallScreen = window.innerWidth < BREAKPOINT;

                setIsMobile(isSmallScreen);

                // IMPORTANT: on ne force sidebarOpen QUE si on traverse le breakpoint
                if (prevIsSmallRef.current !== isSmallScreen) {
                    setIsCriteriaSidebarOpen(!isSmallScreen);
                    prevIsSmallRef.current = isSmallScreen;
                }
            }, 100);
        };

        // init
        const isSmallScreen = window.innerWidth < BREAKPOINT;
        setIsMobile(isSmallScreen);
        setIsCriteriaSidebarOpen(!isSmallScreen);
        prevIsSmallRef.current = isSmallScreen;

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            clearTimeout(resizeTimer);
        };
    }, []);

    const toggleCriteriaSidebar = () => setIsCriteriaSidebarOpen(prev => !prev);
    const openCriteriaDrawer = () => setIsCriteriaDrawerOpen(true);
    const closeCriteriaDrawer = () => setIsCriteriaDrawerOpen(false);

    return {
        isCriteriaDrawerOpen,
        isMobile,
        isCriteriaSidebarOpen,
        isCommentsSidebarOpen,
        rightPanelMode,
        showAllComments,
        hoveredRef,
        selectedRef,
        setRightPanelMode,
        setShowAllComments,
        setHoveredRef,
        setSelectedRef,
        setIsCriteriaSidebarOpen,
        setIsCommentsSidebarOpen,
        toggleCriteriaSidebar,
        openCriteriaDrawer,
        closeCriteriaDrawer
    };
};
